import { render, staticRenderFns } from "./CreateRfid.vue?vue&type=template&id=38581b33"
import script from "./CreateRfid.vue?vue&type=script&lang=js"
export * from "./CreateRfid.vue?vue&type=script&lang=js"
import style0 from "./CreateRfid.vue?vue&type=style&index=0&id=38581b33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports